<template>
  <div class="intro-wrapper">
    <div class="headline-wrapper">
      <h1>{{ slide.title }}</h1>
    </div>
    <h2>{{ slide.text }}</h2>
    <img :src="slide.image" alt=""/>
    <button v-if="this.$store.state.isCandyCodesComplete" class="button previous-button bottom left" @click="goToPreviousSlide">←</button>
    <button class="button start-button bottom right" @click="goToNextSlide"><span class="start-correct">{{(this.$store.state.isContinuing) ? 'continue' : 'start'}}</span> →</button>
  </div>
</template>

<script>

export default {
  name: 'Intro',
  props: [
    'slide',
    'slider',
    'index',
  ],
  mounted() {
  },
  methods: {
    goToNextSlide() {
      if (this.$store.state.isMobile && this.$store.state.isChrome) {
        this.goFullscreen()
      }
      if (this.$store.state.isContinuing) {
        this.$store.dispatch('setIsContinuing', false)
        this.slider.select(this.$store.state.slidesComplete + 1, false, true)
        this.$eventHub.$emit('slideSettled')
      } else {
        this.slider.next()
      }
    },
    goToPreviousSlide() {
      this.slider.previous()
    },
    goFullscreen() {
      const isInFullScreen = (document.fullScreenElement && document.fullScreenElement !== null) || // alternative standard method
              (document.mozFullScreen || document.webkitIsFullScreen)

      const docElm = document.documentElement
      if (!isInFullScreen) {
        if (docElm.requestFullscreen) {
          docElm.requestFullscreen()
        } else if (docElm.mozRequestFullScreen) {
          docElm.mozRequestFullScreen()
        } else if (docElm.webkitRequestFullScreen) {
          docElm.webkitRequestFullScreen()
        }
      }
    },
  },


}

</script>


<style lang="scss" scoped>

@mixin small {
  @media (max-width: 320px) {
    @content;
  }
}

@mixin tablet {
  @media (min-width: 768px) {
    @content;
  }
}

@mixin desktop {
  @media (min-width: 1300px) {
    @content;
  }
}


.intro-wrapper {
  height: 100%;
  width: 100%;
  position: absolute;
  overflow: hidden;

  .headline-wrapper {
    width: 100%;
    top: 18px;
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;

    @include tablet {
      top:13px;
    }

    @include desktop {
      top:7px;
    }
  }

  h2 {
    position: absolute;
    top: 22%;
    width: 60%;
    margin-left: 40px;

    @include tablet {
      top: 18%;
      margin-left: 58px;
    }

    @include desktop {
      width: 60%;
      top: 19%;
    }

  }
  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
  .start-correct {
    @include tablet {
      font-size: 51px;
    }

    @include desktop {

    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Intro.vue